import React, { useCallback, useEffect, useMemo, useState } from "react";
import { CLASSROOM_PLAN, CLASSROOM_PLAN_PREVIEW, CLASSROOM_SERVICES_ADD, CLASSROOM_SERVICES_EDIT, CLASSROOM_SERVICESd_Detail, SCHOOL_CLASSROOM_PLAN } from "config/paths";
import { Button, Col, Container, Dropdown, Form, Row } from "react-bootstrap";
import styles from "./myfavorite.module.scss";
import { generatePath, Link, useNavigate } from "react-router-dom";
import { useDeleteClassroomConsultationMutation, useGetClassroomConsultationListQuery } from "store/services/classroom";
import LoadingIndicator from "components/shared/LoadingIndicator";
import ErrorComponent from "components/shared/ErrorComponent";
import LoadingOverlay from "components/shared/LoadingOverlay";
import TableLayout from "components/TableLayout";
import { CommonSelect, CommonToolTip, CstmPagination } from "components/Common/Common";
import { useDivisionLookupQuery, useLazySchoolLookupQuery } from "store/services/utility";
import { DeleteIcon, EditIcon, EyeOpenIcon, FileIcon } from "Assets/icons";
import TableHeader from "components/shared/FormComponents/TableHeader";
import { cloneDeep, debounce } from "lodash";
import ConfirmationPop from "components/Modals/ConfirmationPop";
import { successMessageToast, userFullName } from "helpers/common";
import { GRADE_OPTIONS, REPORT_IDS } from "config/constants";
import SearchListCheckbox from "components/shared/SearchListCheckbox";
import ClassroomReportsModal from "components/Modals/ClassroomReportsModal";
const ClassRoom = () => {

  const navigate = useNavigate();

  const [pageSize, setPageSize] = useState(10);
  const [currentPage, setCurrentPage] = useState(1);
  const [filter, setFilter] = useState({ search: "", school: "", grade: "", status: "", sort: { column: "id", direction: "desc" } });
  const [schoolOptionList, setSchoolOptionList] = useState([]);
  const [showModal, setShowModal] = useState(false);
  const [currentEntry, setCurrentEntry] = useState(null);
  const [schoolOptions, setSchoolOptions] = useState([]);
  const [reportsModal, setReportsModal] = useState(false)

  const { data, isLoading, isError, isFetching } = useGetClassroomConsultationListQuery({ page: currentPage, limit: pageSize, ...filter });
  const totalRecords = data?.totalRecords || 0;
  const totalPages = Math.ceil(totalRecords / pageSize);

  const [consultationList, setConsultationList] = useState([]);

  // School division Lookup
  const { data: schoolDivisonsList } = useDivisionLookupQuery();

  // School Lookup
  const [getSchoolList, { isFetching: getSchoolListFetching }] = useLazySchoolLookupQuery();
  const [deleteConsultation, { isLoading: deleteConsultationLoading }] = useDeleteClassroomConsultationMutation();

  const gradeOptions = useMemo(() => [{ label: "Select Grade", value: "" }, ...GRADE_OPTIONS], []);

  const getSchoolOptions = async (search) => {
    try {

      const result = await getSchoolList(search);
      if (result?.data) setSchoolOptionList(result?.data);

    } catch (error) { console.log("Error Getting school options"); };

  };

  const handleSearch = useCallback(debounce((value) => {
    if (value) getSchoolOptions(value);
  }, 500), []);

  const resetFilter = () => {
    setFilter({ search: "", school: "", grade: "", status: "", sort: { column: "id", direction: "desc" } });
    setCurrentPage(1)
  };

  const handleFilterChange = (key) => (value) => {
    setFilter((prevState) => ({
      ...prevState,
      [key]: value,
    }));
    setCurrentPage(1); // Reset to first page when filter changes
  };

  const handlePageChange = (page) => {
    window.scrollTo(0, 0);
    setCurrentPage(page);
  };

  const handleDelete = async () => {
    try {

      setShowModal(false);
      const list = cloneDeep(consultationList);
      const index = list.findIndex(x => x.id == currentEntry?.id);
      if (index > -1) delete list[index];
      setConsultationList(list?.filter(Boolean));

      const result = await deleteConsultation(currentEntry?.id);
      if (!result?.error) successMessageToast(result?.data?.message);

    } catch (err) {
      console.error("error deleting classroom consultation", err);
    };
  };

  const columns = [
    {
      head: "Title",
      accessor: "title",
      isComponent: true,
      component: (item, ind) => (
        <h6 className="m-0 fw-sbold text-capitalize">{item?.title || "-"}</h6>
      ),
    },
    {
      head: "School",
      accessor: "school",
      isComponent: true,
      component: (item, ind) => (
        <div className="text-capitalize">{item?.PreflightSchool?.name || "-"}</div>
      ),
    },
    {
      head: "Teacher",
      accessor: "teacher",
      isComponent: true,
      component: (item, ind) => (
        <div className="text-capitalize">{userFullName(item?.PreflightTeacher) || "-"}</div>
      ),
    },
    {
      head: "Grade",
      accessor: "FirstName",
      isComponent: true,
      component: (item, ind) => (
        <h6 className="m-0 fw-sbold">{item?.grade || "-"}</h6>
      ),
    },
    // {
    //   head: "Status",
    //   accessor: "status",
    //   sorter: true,
    //   isComponent: true,
    //   component: (item, ind) => (
    //     <p
    //       style={{ width: 80 }}
    //       className={`${item?.status == "pending"
    //         ? "redStatus"
    //         : "greenStatus"
    //         } status fw-bold text-capitalize m-0 text-center d-flex align-items-center justify-content-center rounded-pill px-4 py-1`}
    //     >
    //       {item?.status}
    //     </p>
    //   ),
    // },
    {
      head: "Action",
      accessor: "",
      isComponent: true,
      component: (item) => (
        <div className="ActnBtn d-flex align-items-center  gap-10">
          <CommonToolTip
            text={"Preview"}
            component={<Button
              className="p-0"
              variant="transparent"
              type="button"
              // onClick={() => {
              //   navigate(generatePath(CLASSROOM_PLAN_PREVIEW, {
              //     assessmentId: REPORT_IDS["CLASSROOM_PLAN"],
              //     clientId: item.id,
              //   }))
              // }}
              onClick={() => {
                setCurrentEntry(item)
                setReportsModal(true)
              }}
            >
              <EyeOpenIcon style={{ opacity: "0.7" }} />
            </Button>}
          />
          <CommonToolTip
            text={"Create Report"}
            component={<Button
              className="p-0"
              variant="transparent"
              type="button"
              onClick={() => {
                navigate(generatePath(SCHOOL_CLASSROOM_PLAN, {
                  assessmentId: REPORT_IDS["CLASSROOM_PLAN_V2"],
                  classroomId: item.id,
                }))
              }}
            >
              <FileIcon />
            </Button>}
          />
          <CommonToolTip
            text={"Edit"}
            component={<Button
              className="p-0"
              variant="transparent"
              type="button"
              onClick={() => navigate(CLASSROOM_SERVICES_EDIT?.replace(":id", item?.id))}
            >
              <EditIcon />
            </Button>}
          />
          <CommonToolTip
            text={"Delete"}
            component={<Button
              className="p-0"
              variant="transparent"
              type="button"
              onClick={() => {
                setCurrentEntry(item);
                setShowModal(true);
              }}
            >
              <DeleteIcon />
            </Button>}
          />
        </div>
      ),
    },
  ];

  useEffect(() => {
    getSchoolOptions();
  }, []);

  useEffect(() => {
    if (data?.records) setConsultationList(data?.records || []);
  }, [data]);

  return (
    <>
      <ConfirmationPop
        confirmation={showModal}
        setConfirmation={setShowModal}
        confirmHandler={handleDelete}
        type="delete"
      />
      <ClassroomReportsModal
        show={reportsModal}
        setShow={setReportsModal}
        currentEntry={currentEntry}
      />
      <section className="client position-relative py-4">
        <Container fluid>
          <Row>
            <Col lg="12" className="my-2">
              <div className="TableFilter d-flex align-items-center justify-content-between gap-10 flex-wrap">
                <div className="left">
                  <TableHeader
                    heading={"Classroom Consultation Caseload"}
                    filter={filter}
                    handleFilterChange={handleFilterChange}
                    resetFilter={resetFilter}
                    searchPlaceholder="Title"
                    filterComponent={
                      <>
                        <li className="">
                          <SearchListCheckbox

                            type="radio"
                            inputPlaceholder={"Search Board Name"}
                            title={schoolDivisonsList?.find(x => x.id == filter?.division)?.title || "School Division"}
                            options={schoolDivisonsList?.map((item) => ({
                              label: item?.title,
                              value: item?.id,
                            }))}
                            handleChange={(selected) => {
                              setSchoolOptions(
                                schoolDivisonsList.find(
                                  (division) => division.id === selected
                                )?.schools || []
                              );
                            }}
                          />
                        </li>
                        <li>
                          <Dropdown onSelect={(selected) => handleFilterChange("school")(selected)}>
                            <Dropdown.Toggle
                              className={`ps-3 text-capitalize border-start rounded-0 pe-0 border-0 themeBlue d-flex align-items-center`}
                              variant="transparent"
                              id="dropdown-basic"
                            >
                              <div className="d-flex">
                                <div style={{ width: "120px", overflow: "hidden", textOverflow: "ellipsis", boxSizing: "border-box" }}>
                                  {schoolOptions.find(x => x.id == filter?.school)?.name || "Select School"}
                                </div>
                                <span className="icn" style={{ marginRight: "20px" }}>
                                  <svg
                                    xmlns="http://www.w3.org/2000/svg"
                                    width="12"
                                    height="8"
                                    viewBox="0 0 12 8"
                                    fill="none"
                                  >
                                    <path
                                      d="M1.415 0.298828L6 4.731L10.585 0.298828L12 1.66666L6 7.46666L0 1.66666L1.415 0.298828Z"
                                      fill="black"
                                    />
                                  </svg>
                                </span>
                              </div>
                            </Dropdown.Toggle>

                            <Dropdown.Menu style={{ maxHeight: "250px", overflowY: "auto" }}                        >
                              {schoolOptions?.length ? schoolOptions?.map((item, index) => {
                                return <Dropdown.Item eventKey={item?.id}>{item?.name}</Dropdown.Item>
                              }) : <>
                                <Dropdown.Item disabled eventKey={""}>No Record Found</Dropdown.Item>

                              </>
                              }
                            </Dropdown.Menu>
                          </Dropdown>
                        </li>
                        <li>
                          <Dropdown onSelect={(selected) => handleFilterChange("grade")(selected)}>
                            <Dropdown.Toggle
                              className={`ps-3 text-capitalize border-start rounded-0 pe-0 border-0 themeBlue d-flex align-items-center`}
                              variant="transparent"
                              id="dropdown-basic"
                            >
                              <div className="d-flex">
                                <div style={{ width: "120px", overflow: "hidden", textOverflow: "ellipsis", boxSizing: "border-box" }}>
                                  {gradeOptions.find(x => x.value == filter?.grade)?.label || "Select Grade"}
                                </div>
                                <span className="icn" style={{ marginRight: "20px" }}>
                                  <svg
                                    xmlns="http://www.w3.org/2000/svg"
                                    width="12"
                                    height="8"
                                    viewBox="0 0 12 8"
                                    fill="none"
                                  >
                                    <path
                                      d="M1.415 0.298828L6 4.731L10.585 0.298828L12 1.66666L6 7.46666L0 1.66666L1.415 0.298828Z"
                                      fill="black"
                                    />
                                  </svg>
                                </span>
                              </div>
                            </Dropdown.Toggle>

                            <Dropdown.Menu style={{ maxHeight: "250px", overflowY: "auto" }}                        >
                              {gradeOptions?.length ? gradeOptions?.map((item, index) => {
                                return <Dropdown.Item key={index} eventKey={item?.value}>{item?.label}</Dropdown.Item>
                              }) :
                                <>
                                  <Dropdown.Item disabled eventKey={""}>No Record Found</Dropdown.Item>
                                </>
                              }
                            </Dropdown.Menu>
                          </Dropdown>
                        </li>
                      </>
                    }
                  />
                </div>
                <div className="right">
                  <ul className="list-unstyled ps-0 mb-0 d-flex align-items-center justify-content-center flex-wrap gap-10">
                    <li className="">
                      <Link
                        to={CLASSROOM_SERVICES_ADD}
                        className="btn text-white d-flex align-items-center justify-content-center commonBtn fw-sbold "
                      >
                        <span className="icn me-1">
                          <svg
                            xmlns="http://www.w3.org/2000/svg"
                            width="19"
                            height="19"
                            viewBox="0 0 19 19"
                            fill="none"
                          >
                            <mask
                              id="mask0_0_4440"
                              style={{ maskType: "alpha" }}
                              maskUnits="userSpaceOnUse"
                              x="0"
                              y="0"
                              width="19"
                              height="19"
                            >

                              <rect
                                width="18.7197"
                                height="18.7197"
                                fill="#D9D9D9"
                              />
                            </mask>
                            <g mask="url(#mask0_0_4440)">
                              <path
                                d="M8.57996 13.2594H10.1399V10.1394H13.2599V8.57947H10.1399V5.45951H8.57996V8.57947H5.46V10.1394H8.57996V13.2594ZM9.35995 17.1593C8.28096 17.1593 7.26698 16.9546 6.31799 16.5451C5.369 16.1356 4.54352 15.5799 3.84153 14.8779C3.13954 14.1759 2.58379 13.3504 2.1743 12.4014C1.76481 11.4524 1.56006 10.4384 1.56006 9.35946C1.56006 8.28047 1.76481 7.26649 2.1743 6.3175C2.58379 5.36851 3.13954 4.54303 3.84153 3.84104C4.54352 3.13905 5.369 2.58331 6.31799 2.17381C7.26698 1.76432 8.28096 1.55957 9.35995 1.55957C10.4389 1.55957 11.4529 1.76432 12.4019 2.17381C13.3509 2.58331 14.1764 3.13905 14.8784 3.84104C15.5804 4.54303 16.1361 5.36851 16.5456 6.3175C16.9551 7.26649 17.1598 8.28047 17.1598 9.35946C17.1598 10.4384 16.9551 11.4524 16.5456 12.4014C16.1361 13.3504 15.5804 14.1759 14.8784 14.8779C14.1764 15.5799 13.3509 16.1356 12.4019 16.5451C11.4529 16.9546 10.4389 17.1593 9.35995 17.1593ZM9.35995 15.5994C11.1019 15.5994 12.5774 14.9949 13.7864 13.7859C14.9954 12.5769 15.5999 11.1014 15.5999 9.35946C15.5999 7.61748 14.9954 6.142 13.7864 4.93302C12.5774 3.72404 11.1019 3.11955 9.35995 3.11955C7.61797 3.11955 6.14249 3.72404 4.93351 4.93302C3.72453 6.142 3.12004 7.61748 3.12004 9.35946C3.12004 11.1014 3.72453 12.5769 4.93351 13.7859C6.14249 14.9949 7.61797 15.5994 9.35995 15.5994Z"
                                fill="white"
                              />
                            </g>
                          </svg>
                        </span>{" "}
                        Add New Consultation
                      </Link>
                    </li>
                  </ul>
                </div>
              </div>
              <div className="table-outer">
                {isLoading ? (
                  <div style={{ height: "200px" }}>
                    <LoadingIndicator />
                  </div>
                ) : isError ? (
                  <ErrorComponent />
                ) : (
                  <>
                    {(isFetching || deleteConsultationLoading) && <LoadingOverlay />}
                    <TableLayout
                      data={consultationList || []}
                      column={columns}
                    />
                  </>
                )}
                <CstmPagination
                  totalPages={totalPages}
                  activePage={currentPage}
                  handlePageChange={handlePageChange}
                />
              </div>
            </Col>
          </Row>
        </Container>
      </section>
    </>
  );
};

export default ClassRoom;
